import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Link, useNavigate } from 'react-router-dom';

import './styles.scss';
import { handleData } from '../../helpers';
import { getSingleEvent, eventGoing, eventNotGoing } from '../../../../actionCreators/events';
import { logFirebaseEvent } from '../../../../firebase/analytics';

import { dateDifferenceShorted } from '../../../../utils/helpers';
import ImageApi from '../../../../api/image';
import Participant from './Participant';
import ShowAllParticipantsModal from '../../../../components/ShowAllEventParticipantsModal';
import { Portal, RoundedSwitch } from '../../../../components';
import UserPlaceholder from '../../../../assets/images/user_placeholder.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  deletePostRequest,
  reportPostRequest,
  resetPostRequestSuccess,
} from '../../../../actionCreators/feedActions';
import ErrorModal from '../../../../components/ErrorModal';

import {
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Dropdown,
  Input,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from 'reactstrap';
import Linkify from 'react-linkify';

const EventItem = (props) => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    imageUrl: '',
    groupTitle: '',
    userAvatar: '',
    showAllParticipants: false,
    menuOpen: false,
    confirmModalOpen: false,
    isErrorModalOpen: false,
    errorModalTitle: '',
    errorModalMessage: '',
    selectedReportingReason: null,
    reportPostDescription: '',
    reportSubmitted: false,
  });

  const [modalState, setModalState] = useState({
    showReport: false,
    showDelete: false,
    reportSubmitted: false,
  });

  useEffect(() => {
    const getImages = async () => {
      try {
        if (props.eventItem.post.image.url) {
          const imageUrl = await ImageApi.getImage(props.eventItem.post.image.url);
          const userAvatarImageUrl = await ImageApi.getImage(props.author.image.thumbnailUrl);
          setState({ ...state, imageUrl: imageUrl, userAvatar: userAvatarImageUrl });
        }
      } catch (err) {}
    };
    getImages();
  }, [props.author.image.thumbnailUrl, props.eventItem.post.image.url]);

  const handleEvent = (type) => {
    if (type) {
      props.eventGoing(props.postId);
      logFirebaseEvent({
        event: 'events',
        action: 'going',
      });
    } else {
      props.eventNotGoing(props.postId);
      logFirebaseEvent({
        event: 'events',
        action: 'not_going',
      });
    }
  };

  const resetPostReportModal = () => {
    setState({
      ...state,
      selectedReportingReason: null,
      reportPostDescription: '',
    });
    setModalState({
      ...modalState,
      showReport: false,
      reportSubmitted: false,
      showDelete: false,
      deleteSubmitted: false,
    });
  };

  const toggleMenu = () => {
    setState({ ...state, menuOpen: !state.menuOpen });
  };

  const toggleDeleteConfirmModal = () => {
    resetPostReportModal();
    setModalState({ ...modalState, showDelete: !modalState.showDelete });
  };

  const deletePost = async () => {
    logFirebaseEvent({
      event: 'delete_post',
    });
    await props.deletePost({ postId: props.postableId });
    navigate(-1);
  };

  const toggleReportPostModal = () => {
    resetPostReportModal();
    setModalState({ ...modalState, showReport: !modalState.showReport });
  };

  const toggleReportPostSubmitted = () => {
    resetPostReportModal();
    setModalState({ ...modalState, reportSubmitted: !modalState.reportSubmitted });
  };

  const reportPost = async () => {
    // validating
    if (!state.selectedReportingReason) return;

    logFirebaseEvent({
      event: 'report_post',
    });
    await props.reportPost({
      postId: props.postableId,
      reason_type: state.selectedReportingReason,
      reason_text: state.reportPostDescription,
    });

    setModalState({ ...modalState, showReport: false, reportSubmitted: true });
  };

  const resetErrorModal = () => {
    setState({
      ...state,
      isErrorModalOpen: false,
      errorModalTitle: '',
      errorModalMessage: '',
    });
  };

  const { eventItem, author, group } = props;
  const event = eventItem.post;

  const sameDay = event.end_time && moment(event.start_time).isSame(event.end_time, 'day');
  const startDate = moment(event.start_time);
  const endDate = moment(event.end_time);

  const currentTime = new Date();
  const endTime = event && new Date(event.end_time);
  const isPassed = event && event.end_time !== null ? currentTime - endTime : -1;

  console.warn('state EventItem');
  console.warn(modalState);

  return (
    <div className="feed event-single-main">
      <Modal isOpen={modalState.reportSubmitted} centered>
        <ModalHeader toggle={toggleReportPostSubmitted}>
          <div>Report received</div>
        </ModalHeader>
        <ModalBody>
          <div>
            Thank you for your report. It will be reviewed by an administrator who will take
            appropriate action
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" className={'w-100'} onClick={toggleReportPostSubmitted} outline>
            OKAY
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalState.showDelete} centered>
        <ModalHeader>
          <div>Confirm</div>
        </ModalHeader>
        <ModalBody>
          <div>Do you want to delete it?</div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggleDeleteConfirmModal}>
            Cancel
          </Button>
          <div style={{ flex: 1 }} />
          <Button color="primary" onClick={() => deletePost()}>
            Confirm
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalState.showReport} centered style={{ maxWidth: '600px', width: '100%' }}>
        <ModalHeader toggle={toggleReportPostModal}>
          <div>Report Post</div>
        </ModalHeader>
        <ModalBody>
          <UncontrolledDropdown>
            <DropdownToggle
              data-toggle="dropdown"
              outline
              style={{ width: '100%', textAlign: 'left' }}
              color={'secondary'}
            >
              <div>
                {state.selectedReportingReason
                  ? props.postReportTypes.find(
                      (postReportType) => postReportType.id === state.selectedReportingReason,
                    ).report_type_text
                  : 'Select reason'}
              </div>
            </DropdownToggle>
            <DropdownMenu>
              {props.postReportTypes &&
                props.postReportTypes.map((postReportType) => {
                  return (
                    <DropdownItem
                      key={postReportType.id}
                      onClick={() =>
                        setState({ ...state, selectedReportingReason: postReportType.id })
                      }
                    >
                      {postReportType.report_type_text}
                    </DropdownItem>
                  );
                })}
            </DropdownMenu>
          </UncontrolledDropdown>
          <div style={{ width: '100%', height: 20 }} />
          <Input
            type="textarea"
            name="text"
            id="description"
            placeholder={'Description (optional)'}
            maxLength={240}
            onChange={(e) => setState({ ...state, reportPostDescription: e.target.value })}
          />
        </ModalBody>
        <ModalFooter>
          <div style={{ flex: 1 }} />
          <Button className="modal-button" onClick={reportPost}>
            SUBMIT REPORT
          </Button>
        </ModalFooter>
      </Modal>

      <ErrorModal
        isOpen={state.isErrorModalOpen}
        title={state.errorModalTitle}
        message={state.errorModalMessage}
        onClose={resetErrorModal}
      />
      <div className="event-single-container">
        <div className="main-event-container">
          {event.image_id && (
            <div className="img-title">
              <img className="img-title event-bottom-cover" src={state.imageUrl} alt="event" />
            </div>
          )}
          <div className="event-avatar-section d-flex justify-content-between">
            <div className="d-flex flex-fill justify-content-between">
              <div className="d-flex">
                {state.userAvatar ? (
                  <img className="event-bottom-cover" src={state.userAvatar} alt="" />
                ) : (
                  <img className="event-bottom-cover" src={UserPlaceholder} alt="" />
                )}
                <h3 className="title">
                  <Link to={`/users/${author.id}`} className="title__link">
                    {author.first_name} {author.last_name}
                  </Link>

                  <span className="font-weight-light ms-1 me-1">in</span>

                  <Link to={`/group-feed/${group.id}`} className="title__link">
                    {group.name}
                  </Link>

                  <br />
                  <span className="subtitle">
                    {event && dateDifferenceShorted(event.created_at)}
                  </span>
                </h3>
              </div>
              <div>
                <Dropdown isOpen={state.menuOpen} direction="left" toggle={toggleMenu}>
                  <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={state.menuOpen}>
                    <FontAwesomeIcon
                      className="feed-item-header-collapse"
                      icon={['fas', 'chevron-down']}
                    />
                  </DropdownToggle>
                  <DropdownMenu>
                    {(props.currentUser.userData.is_admin ||
                      !!group.is_moderator ||
                      props.currentUser.userData.id === author.id) && (
                      <DropdownItem onClick={toggleDeleteConfirmModal}>Delete</DropdownItem>
                    )}
                    <DropdownItem onClick={toggleReportPostModal}>Report Post</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>
          </div>

          <div className="event-single-calendar d-flex">
            <div className="calendar">
              <div className="event-container">
                <span className="month">{event && handleData(event.start_time).month}</span> <br />
                <span className="number">{event && handleData(event.start_time).day}</span>
              </div>
            </div>
            <h3 className="event-single-title">{event && event.title}</h3>
          </div>

          <div className="event-single-information">
            <div className="date d-flex align-items-center">
              {startDate.format('HH:mma')}
              {!sameDay && (
                <>
                  <div className="oval" />
                  {startDate.format('dddd')}
                </>
              )}

              {event.end_time && (
                <>
                  {' - '}
                  {endDate.format('HH:mma')}
                  <div className="oval" />
                  {endDate.format('dddd')}
                </>
              )}
            </div>

            <p className="location">{event && event.location}</p>
            <p className="description">
              <Linkify
                componentDecorator={(href, text, key) => (
                  <a href={href} key={key} target={'_blank'}>
                    {text}
                  </a>
                )}
              >
                {event && event.description}
              </Linkify>
            </p>
          </div>
          {event && event.participants < 1 ? null : (
            <div className="event-single-attending d-flex align-items-center justify-content-end">
              <Link
                to={{ search: '?type=event&listType=event&showUsers=true' }}
                className="subtitle"
              >
                {event && event.participants.length} Attending
              </Link>
              {event &&
                event.participants.slice(0, 3).map((participant) => {
                  return (
                    <Participant key={participant.user_id} participant={participant.user_id} />
                  );
                })}
              {event && event.participants.length > 3 && (
                <div
                  onClick={() => {
                    setState({ ...state, showAllParticipants: true });
                  }}
                  className="rest-users cursor-pointer"
                >
                  +{event && event.participants.length - 3}
                </div>
              )}
              <Portal
                hide={() => setState({ ...state, showAllParticipants: false })}
                isOpen={state.showAllParticipants}
              >
                <ShowAllParticipantsModal
                  participants={event.participants}
                  hide={() => setState({ ...state, showAllParticipants: false })}
                  title={`${event.participants.length} Attending`}
                />
              </Portal>
            </div>
          )}
          <div className="divider" />
          {isPassed < 0 ? (
            <div className="event-visiting-container d-flex justify-content-end">
              <RoundedSwitch
                updateChecked={handleEvent}
                checked={event.is_going}
                textOff="Can't go"
                textOn="Going"
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const EventItemContainer = (props) => {
  const state = useSelector((state) => ({
    postReportTypes: state.feed.postReportTypes,
    reportPostRequestSuccessful: state.feed.reportPostRequestSuccessful,
    currentUser: state.currentUser,
  }));

  const dispatch = useDispatch();

  const actions = {
    handleEvent: (payload) => dispatch(getSingleEvent(payload)),
    eventGoing: (payload) => dispatch(eventGoing(payload)),
    eventNotGoing: (payload) => dispatch(eventNotGoing(payload)),
    deletePost: (payload) => dispatch(deletePostRequest(payload)),
    reportPost: (payload) => dispatch(reportPostRequest(payload)),
    resetPostRequestSuccess: () => dispatch(resetPostRequestSuccess()),
  };

  return <EventItem {...props} {...state} {...actions} />;
};

export default EventItemContainer;
